// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "img[data-v-97895ce0]{border-radius:var(--image-border-radius);display:block;height:100%;-o-object-fit:cover;object-fit:cover;transition:.25s ease-in-out;width:100%;}img.v-lazy-image[data-v-97895ce0]{opacity:0}img.v-lazy-image-loaded[data-v-97895ce0]{opacity:1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
